import MedalGlyph from './MedalGlyph.jsx';
import s from './PlateCard.module.css';

export default function PlateCard({
  mediaSrc,
  mediaAlt = '',
  mediaType = 'image',
  mediaControls = true,
  liftName,
  weight,
  reps,
  athlete,
  isPR = false,
  rank = null,
  footer = null,
  className = '',
  children,
  ...rest
}) {
  const cls = [s.plate, isPR ? s.pr : ''].filter(Boolean).join(' ');
  const showMedal = isPR || rank === 'gold' || rank === 'silver' || rank === 'bronze';
  return (
    <article className={`${cls} ${className}`.trim()} {...rest}>
      <div className={s.media}>
        {mediaType === 'video'
          ? <video src={mediaSrc} {...(mediaControls ? { controls: true } : { muted: true, playsInline: true })} />
          : <img src={mediaSrc} alt={mediaAlt} />}
        {showMedal && (
          <MedalGlyph
            className={s.medal}
            name={isPR ? 'pr' : 'rank'}
            rank={rank || (isPR ? undefined : 'gold')}
            size="md"
          />
        )}
        {children}
      </div>
      <div className={s.meta}>
        <span className={s.lift}>{liftName}</span>
        <span className={s.weight}>{weight}{reps ? ` × ${reps}` : ''}</span>
        {athlete && <span className={s.athlete}>{athlete}</span>}
      </div>
      {footer && <div className={s.footer}>{footer}</div>}
    </article>
  );
}
